export default __webpack_public_path__ + "static/media/headerPdf.7043352a.png";